import _ from "lodash";
import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';
import codeMasterModel from "../common/code-master.model";
import moment from "moment";

var vocModel = {

    getVocList: function (successCallback, failureCallback, filter) {
        // Set required default values
        const params = {
            pageIndex: 1,
            pageSize: 10,
        }

        Object.assign(params, filter);

        modelBase.post(successCallback, failureCallback, '/api/voc/list', { body: params });
    },

    exportVocListToPptx: function (successCallback, failureCallback, filter, fileName = `VOC List - ${moment().format('YYYYMMDDHHmm')}.pptx`) {
        modelBase.postDownload(successCallback, failureCallback, '/api/voc/file/pptx', { body: filter }, fileName);
    },

    exportVocListToExcel: function (successCallback, failureCallback, filter, fileName = `VOC List - ${moment().format('YYYYMMDDHHmm')}.xlsx`) {
        modelBase.postDownload(successCallback, failureCallback, '/api/voc/file/excel', { body: filter }, fileName);
    },

    getVocSummary: function (successCallback, failureCallback, filter) {
        // Set required default values
        const params = {
            pageIndex: 1,
            pageSize: 10,
        }

        Object.assign(params, filter);

        modelBase.post(successCallback, failureCallback, '/api/voc/summary', { body: params });
    },

    getSingleVoc: function (successCallback, failureCallback, vocId) {

        vocId = encodeURIComponent(vocId);

        modelBase.get(successCallback, failureCallback, '/api/voc?vocid=' + vocId, {});
    },

    uploadMultipleFilesForVoc: function (successCallBack, failureCallBack, formData) {
        var path = '/api/retail/file/VOC/multiple';

        modelBase.post(successCallBack, failureCallBack, path, { body: formData });
    },

    updateVocInfo: function (successCallback, failureCallback, vocId, inputDataModel) {
        var params = {};
        params.vocId = vocId;

        params.pic = inputDataModel.picUserId.trim();
        params.reviseDueDate = inputDataModel.revisedDueDate.trim();
        params.statusUpdate = inputDataModel.updateStatus;
        params.reasonUpdate = inputDataModel.updateReason;
        params.remarks = inputDataModel.updateNotes.trim();

        params.fileMasterIDs = inputDataModel.fileMasterIds.trim();
        params.isFileUploadOnly = inputDataModel.isFromRequestor || inputDataModel.isFileUploadOnly;

        if (!params.isFileUploadOnly && params.pic.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please specify the person in charge." });

            failureCallback(error);

            return;
        }

        if (!params.isFileUploadOnly && params.remarks.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please put in a remark about this VOC update." });

            failureCallback(error);

            return;
        }

        var path = '/api/voc/vocUpdate';
        modelBase.post(successCallback, failureCallback, path, { body: params });
    },

    getVocMessages: function (successCallback, failureCallback, vocId) {

        vocId = encodeURIComponent(vocId);

        modelBase.get(successCallback, failureCallback, '/api/voc/comm/list?vocid=' + vocId, {});
    },

    addVocMessage: function (successCallback, failureCallback, vocId, message) {
        var params = {};
        params.vocId = vocId;
        params.message = message.trim();

        if (params.message.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a message." });

            failureCallback(error);

            return;
        }

        var path = '/api/voc/comm';
        modelBase.post(successCallback, failureCallback, path, { body: params });
    },

    getVocHistoryItems: function (successCallback, failureCallback, vocId) {
        vocId = encodeURIComponent(vocId);

        modelBase.get(successCallback, failureCallback, '/api/voc/history?vocid=' + vocId, {});
    },

    downloadHistoryFileAttachments: function (successCallback, failureCallback, vocHistoryId) {
        vocHistoryId = encodeURIComponent(vocHistoryId);

        modelBase.getDownload(successCallback, failureCallback, '/api/voc/history/file?vochistoryid=' + vocHistoryId, {}, 'voc-history-attachments.zip');
    },

    downloadSingleFileAttachment: function (successCallback, failureCallback, fileMasterId, fileName) {
        modelBase.getDownload(successCallback, failureCallback, '/api/retail/file/' + fileMasterId, {}, fileName);
    },

    getVocInfo: function (successCallback, failureCallback, vocId) {
        vocId = encodeURIComponent(vocId);

        modelBase.get(successCallback, failureCallback, '/api/voc/infoGet?VOCId=' + vocId, {});
    },

    getVocUpdateReasons: function (successCallback, failureCallback) {
        this.getVocConfigList(successCallback, failureCallback, undefined, 'reason'); // VOC Update Reason
    },

    getVocUpdateStatuses: function (successCallback, failureCallback, vocId) {
        vocId = encodeURIComponent(vocId);

        modelBase.get(successCallback, failureCallback, '/api/voc/vocStatusListForUpdate?VOCId=' + vocId, {});
    },

    deactivateFile: function (successCallback, failureCallback, vocFileMapID) {

        var params = {};

        var path = '/api/voc/filemap/' + vocFileMapID;
        modelBase.post(successCallback, failureCallback, path, { body: params });
    },

    getVocConfigList: function (successCallback, failureCallback, filter = undefined, filterCode = '') {
        // filterCode: category | div | categoryonly | subcategory | item | by | status | reason | config

        // Set required default values
        const configFilter = {};
        Object.assign(configFilter, filter);
        if (filterCode.length > 0) {
            configFilter.code = filterCode;
        }
        const qs = modelBase.toQueryString(configFilter);

        modelBase.get(successCallback, failureCallback, '/api/voc/config?' + qs);
    },

    getAllVocCategoryConfigList: function (successCallback, failureCallback) {
        this.getVocConfigList(successCallback, failureCallback, { code: 'category' }); // Full list: VOC GSCM Div + VOC Category + VOC Sub-category + VOC Item
    },

    getGscmDivisionList: function (successCallback, failureCallback, filter) {
        this.getVocConfigList(successCallback, failureCallback, filter, 'div'); // VOC GSCM Div
    },

    getVocCategoryList: function (successCallback, failureCallback, filter) {
        this.getVocConfigList(successCallback, failureCallback, filter, 'categoryonly'); // VOC Category
    },

    getVocSubcategoryList: function (successCallback, failureCallback, filter) {
        this.getVocConfigList(successCallback, failureCallback, filter, 'subcategory'); // VOC Sub-category
    },

    getVocItemList: function (successCallback, failureCallback, filter) {
        this.getVocConfigList(successCallback, failureCallback, filter, 'item'); // VOC Item
    },

    getVocStatusList: function (successCallback, failureCallback) {
        this.getVocConfigList(successCallback, failureCallback, { code: 'status' }); // VOC Status
    },

    getVocUrgencyList: function (successCallback, failureCallback) {
        codeMasterModel.getByCategory(successCallback, failureCallback, { category: 'UrgencyType' })
    },
}

export default vocModel;
